import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import { InputAdornment, TextField } from '@mui/material';

import { darkPurple, white } from 'utils/color-styles';

interface FormAmountRangeSelectorProps {
  names: string[];
  placeholder?: [string, string];
  style?: React.CSSProperties;
  currencySymbol?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // To allow for dynamic field access
}

/**
 * @NOTE-DP: that's like a really weirdly styled input, to match antd filters. It's all a mess and we should fix it by re-implementing all of the filters using MUI consistently
 */
const StyledTextField = ({
  placeholder,
  onChange,
  value,
  currencySymbol,
}: {
  placeholder: string;
  onChange: (value: string) => void;
  value: number;
  currencySymbol: string;
}) => (
  <TextField
    label={placeholder}
    type="number"
    onChange={(event) => {
      onChange(event.target.value);
    }}
    onBlur={(event) => {
      onChange(event.target.value);
    }}
    value={value}
    style={{ marginRight: 10 }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <span style={{ color: 'rgb(191, 191, 191)' }}>{currencySymbol}</span>
        </InputAdornment>
      ),
      style: {
        background: white,
      },
      inputProps: {
        style: {
          padding: '6px 0',
        },
      },
    }}
    sx={{
      '& .v5-MuiInputLabel-formControl': {
        color: 'rgb(191, 191, 191)',
      },
      '& .v5-MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgb(217, 219, 218)',
        borderWidth: '1px',
        borderRadius: '2px',
        borderStyle: 'solid',
      },
      '&:hover .v5-MuiOutlinedInput-notchedOutline': {
        borderColor: `${darkPurple} !important`,
      },
      '& .Mui-focused .v5-MuiOutlinedInput-notchedOutline': {
        borderColor: darkPurple,
        borderWidth: '1px !important',
      },
    }}
  />
);

const FormAmountRangeSelector = ({
  names,
  placeholder,
  style,
  currencySymbol = '$',
  ...rest
}: FormAmountRangeSelectorProps): JSX.Element => {
  const [minAmountName, maxAmountName] = names;

  const minAmount = rest[minAmountName];
  const maxAmount = rest[maxAmountName];

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          ...style,
        }}
      >
        <StyledTextField
          placeholder={placeholder?.[0] || 'Min amount'}
          onChange={minAmount.input.onChange}
          value={minAmount.input.value}
          currencySymbol={currencySymbol}
        />

        <StyledTextField
          placeholder={placeholder?.[1] || 'Max amount'}
          onChange={maxAmount.input.onChange}
          value={maxAmount.input.value}
          currencySymbol={currencySymbol}
        />
      </div>
      {((minAmount.meta?.error && minAmount.meta?.touched) ||
        (maxAmount.meta?.error && maxAmount.meta?.touched)) && (
        <FormLabel error style={{ fontSize: 12, marginTop: 5 }}>
          {minAmount.meta?.error || maxAmount.meta?.error}
        </FormLabel>
      )}
    </>
  );
};

export default FormAmountRangeSelector;
